import { render, staticRenderFns } from "./AdminDashboardOsInfo.vue?vue&type=template&id=2fb95e93&"
import script from "./AdminDashboardOsInfo.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardOsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports